@if (!isTranslucent && !hideIcon) {
  <div class="info-card__icon">
    <cs-icon [name]="getIconName()"></cs-icon>
  </div>
}
<div class="info-card__message">
  @if (!message) {
    <ng-content></ng-content>
  }
  @if (message) {
    {{ message }}
  }
</div>
@if (actionText) {
  <div class="info-card__action">
    <cs-button small primary (click)="onActionClick($event)">{{ actionText }}</cs-button>
  </div>
}
@if (dismissible && !isTranslucent) {
  <div class="info-card__close" (click)="onClose($event)">
    <cs-icon name="close"></cs-icon>
  </div>
}